import { render } from "./ModalHeader.vue?vue&type=template&id=0f8336a5&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"

import "./ModalHeader.vue?vue&type=style&index=0&id=0f8336a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8336a5"],['__file',"src/components/mdbvue/Modals/ModalHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f8336a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f8336a5', __exports__)) {
    api.reload('0f8336a5', __exports__)
  }
  
  module.hot.accept("./ModalHeader.vue?vue&type=template&id=0f8336a5&scoped=true", () => {
    api.rerender('0f8336a5', render)
  })

}


export default __exports__